export const recipeFullIngredientsViewed = recipe => ({
  type: 'Recipe Full Ingredients Viewed',
  data: {
    recipe,
  },
});

export const recipeIngredientsViewed = recipe => ({
  type: 'Recipe Ingredients Viewed',
  data: {
    recipe,
  },
});

export const recipeIngredientCarouselTurn = (recipe, target) => ({
  type: 'Recipe Ingredient Carousel Turn',
  data: {
    recipe,
    target,
  },
});
